export default function AboutUs() {
  const beliefs = [
    'Honest pricing',
    'Quality parts',
    'Reliable service',
    'Long-term customer relationships'
  ];

  return (
    <section id="about" className="py-20 bg-white relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-white via-gray-50 to-white"></div>
      
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/9941f283800280f05fd4bf961156c515.jpg"
                alt="N.A. Discount Auto Parts Storefront"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-red-600 text-white px-8 py-6 rounded-xl shadow-xl">
              <div className="font-rajdhani font-bold text-5xl">20+</div>
              <div className="font-medium text-sm">Years of Experience</div>
            </div>
          </div>

          <div>
            <h2 className="font-rajdhani font-bold text-4xl md:text-5xl text-black mb-6">
              Over 20 Years of Automotive Experience
            </h2>
            
            <div className="space-y-4 text-gray-700 text-lg leading-relaxed mb-8">
              <p>
                <strong>N.A. Discount Auto Parts</strong> has proudly served the Mississauga community for over 20 years. What started as a passion for cars has grown into a trusted auto parts and service destination.
              </p>
              <p>
                We understand vehicles inside and out. Our decades of hands-on experience allow us to recommend the right parts the first time — saving customers time and money.
              </p>
            </div>

            <div className="mb-8">
              <h3 className="font-rajdhani font-bold text-2xl text-black mb-4">We believe in:</h3>
              <ul className="space-y-3">
                {beliefs.map((belief, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <span className="w-2 h-2 bg-red-600 rounded-full"></span>
                    <span className="text-black font-semibold text-lg">{belief}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-gray-100 border-l-4 border-red-600 p-6 rounded-r-lg">
              <p className="text-gray-600 italic mb-2">Our mission is simple:</p>
              <p className="text-black font-bold text-xl">
                Provide affordable, dependable auto parts backed by real experience and professional service.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
